import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

// bootstrap-vue is not built as it does not publish
import BootstrapVue from 'bootstrap-vue/src/index/'
import '@/style.scss'
import '@/css/ac.css'

Vue.config.productionTip = false
Vue.use(BootstrapVue)

Vue.mixin({
  methods: {
    canPerform: (...permissionsRequired) => {
      // When user id is -1, it means no user is login. There is no need to check permissions in this case.
      if (store.state.currentUser.user.id === -1) {
        return true
      }
      return store.getters['currentUser/permissions/canPerform'](permissionsRequired)
    }
  }
})

Vue.directive('focus', {
  inserted (el) {
    if (el.classList.contains('bsq-form-field')) {
      setTimeout(() => {
        el.getElementsByTagName('input')[0].focus()
      }, 50)
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
  i18n
}).$mount('#app')
